module.exports = __webpack_public_path__ + "static/img/ac.6d84a071.png";